var map = {
	"./skin1/btn.png": "111c",
	"./skin2/btn.png": "d791",
	"./skin3/btn.png": "ca44",
	"./skin4/btn.png": "caaa",
	"./skin5/btn.png": "f487",
	"./skin6/btn.png": "455b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6d38";